<app-page-breadcrumb pageTitle="Tickets"></app-page-breadcrumb>

<div class="space-y-4">
  <!-- Compact Controls Section -->
  <div class="flex items-center justify-between gap-2 flex-wrap">
    <div class="flex items-center gap-2 flex-wrap">
      <!-- Filtro responsable -->
      <div class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
        <button
          type="button"
          (click)="setOwnerFilter('all')"
          class="px-3 py-1.5 text-sm font-medium transition-colors"
          [ngClass]="filtroOwner === 'all'
            ? 'bg-brand-500 text-white'
            : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
          Todos
        </button>
        <button
          type="button"
          (click)="setOwnerFilter('mine')"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
          [ngClass]="filtroOwner === 'mine'
            ? 'bg-brand-500 text-white'
            : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
          Mis tickets
        </button>
      </div>

      <!-- V180: vista de archivados. Archivar no cambia el estado del ticket, así que
           los archivados solo se ven desde aquí. -->
      <div class="flex items-center rounded-lg border border-gray-200 dark:border-gray-700 overflow-hidden">
        <button
          type="button"
          (click)="setArchivedView(false)"
          class="px-3 py-1.5 text-sm font-medium transition-colors"
          [ngClass]="!verArchivados
            ? 'bg-brand-500 text-white'
            : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
          Activos
        </button>
        <button
          type="button"
          (click)="setArchivedView(true)"
          class="px-3 py-1.5 text-sm font-medium transition-colors border-l border-gray-200 dark:border-gray-700"
          [ngClass]="verArchivados
            ? 'bg-brand-500 text-white'
            : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 hover:bg-gray-50 dark:hover:bg-gray-700'">
          Archivados
        </button>
      </div>

      <!-- Saved views selector -->
      @if (savedViews.length > 0) {
        <select
          [ngModel]="selectedSavedViewId"
          (ngModelChange)="onSelectSavedView($event)"
          class="px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="null">— Vistas guardadas —</option>
          @for (v of savedViews; track v.id) {
            <option [ngValue]="v.id">{{ v.name }}{{ v.scope !== 'PRIVATE' ? ' (' + scopeLabel(v.scope) + ')' : '' }}</option>
          }
        </select>
      }
      @if (selectedSavedViewId) {
        <button type="button" (click)="eliminarVista()"
          class="px-2 py-1.5 text-xs rounded-lg border border-error-300 dark:border-error-600 bg-white dark:bg-gray-800 text-error-600 dark:text-error-400 hover:bg-error-50 dark:hover:bg-error-900/20"
          title="Eliminar vista">
          🗑
        </button>
      }
    </div>

    <!-- Right side - Action buttons -->
    <div class="flex items-center gap-1.5">
      <button type="button" (click)="abrirAdvancedModal()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 flex items-center gap-1.5"
        [class.bg-brand-50]="advancedActive"
        [class.text-brand-600]="advancedActive"
        [class.border-brand-300]="advancedActive">
        Búsqueda avanzada
        @if (advancedActive) {
          <span class="text-xs">({{ advancedConditions.length }})</span>
        }
      </button>
      <button type="button" (click)="toggleFilters()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
        {{ showFilters ? 'Ocultar' : 'Filtros' }}
      </button>
      <button type="button" (click)="vistaTablero()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
        Kanban
      </button>
      <button type="button" *appHasPermission="'tickets:create'" (click)="nuevoTicket()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-brand-500 text-white hover:bg-brand-600 flex items-center gap-1.5">
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"></path>
        </svg>
        Nuevo
      </button>
    </div>
  </div>

  <!-- Filtros Panel -->
  @if (showFilters && !advancedActive) {
  <div class="bg-white dark:bg-gray-900 border border-gray-200 dark:border-gray-700 rounded-lg p-3">
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-3">
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Buscar</label>
        <input type="text" [(ngModel)]="filtroTexto" (ngModelChange)="buscarTexto()"
          placeholder="Asunto, #ticket, contacto o empresa…"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Estado</label>
        <select [(ngModel)]="filtroIdStatus" (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todos</option>
          @for (status of statuses; track status.id) {
            <option [ngValue]="status.id">{{ status.label }}</option>
          }
        </select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Prioridad</label>
        <select [(ngModel)]="filtroIdPriority" (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todas</option>
          @for (priority of priorities; track priority.id) {
            <option [ngValue]="priority.id">{{ priority.label }}</option>
          }
        </select>
      </div>
      <div>
        <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Categoría</label>
        <select [(ngModel)]="filtroIdCategory" (ngModelChange)="buscar()"
          class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
          <option [ngValue]="undefined">Todas</option>
          @for (category of categories; track category.id) {
            <option [ngValue]="category.id">{{ category.name }}</option>
          }
        </select>
      </div>
      <div class="flex items-end">
        <button type="button" (click)="limpiarFiltro()"
          class="w-full px-3 py-1.5 text-sm rounded-lg font-medium transition-colors bg-gray-100 dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-200 dark:hover:bg-gray-700">
          Limpiar Filtros
        </button>
      </div>
    </div>
  </div>
  }

  <!-- Indicador de búsqueda avanzada activa -->
  @if (advancedActive) {
  <div class="flex items-center justify-between gap-2 bg-brand-50 dark:bg-brand-900/10 border border-brand-200 dark:border-brand-800 rounded-lg p-3">
    <p class="text-sm text-brand-700 dark:text-brand-300">
      Búsqueda avanzada activa con {{ advancedConditions.length }} condición(es) [{{ advancedCombinator }}].
    </p>
    <div class="flex items-center gap-2">
      @if (canSaveAsView) {
        <button type="button" (click)="abrirSaveViewModal()"
          class="px-3 py-1 text-xs rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600">
          Guardar como vista
        </button>
      } @else {
        <span class="inline-flex items-center gap-1 px-3 py-1 text-xs rounded-lg font-medium bg-success-50 text-success-700 border border-success-200 dark:bg-success-900/20 dark:text-success-300 dark:border-success-800">
          <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7"></path>
          </svg>
          Vista guardada
        </span>
      }
      <button type="button" (click)="abrirAdvancedModal()"
        class="px-3 py-1 text-xs rounded-lg font-medium border border-brand-300 text-brand-700 hover:bg-brand-100 dark:text-brand-300 dark:hover:bg-brand-900/20">
        Editar
      </button>
      <button type="button" (click)="limpiarAdvanced()"
        class="px-3 py-1 text-xs rounded-lg font-medium border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
        Limpiar
      </button>
    </div>
  </div>
  }

  <!-- Bulk action bar -->
  @if (selectedCount > 0) {
  <div class="flex items-center justify-between gap-2 bg-yellow-50 dark:bg-yellow-900/10 border border-yellow-200 dark:border-yellow-800 rounded-lg p-3 flex-wrap">
    <div class="flex items-center gap-2">
      <span class="text-sm font-medium text-yellow-800 dark:text-yellow-300">
        {{ selectedCount }} seleccionado(s)
      </span>
      <button type="button" (click)="clearSelection()"
        class="text-xs text-yellow-700 dark:text-yellow-400 hover:underline">
        Limpiar
      </button>
    </div>
    <div class="flex items-center gap-2 flex-wrap">
      <select #bulkStatus
        [disabled]="bulkInFlight"
        (change)="bulkChangeStatus($any(bulkStatus.value) ? +bulkStatus.value : null); bulkStatus.value = ''"
        class="px-2.5 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
        <option value="">Cambiar estado…</option>
        @for (s of statuses; track s.id) {
          <option [value]="s.id">{{ s.label }}</option>
        }
      </select>

      <select #bulkPriority
        [disabled]="bulkInFlight"
        (change)="bulkChangePriority($any(bulkPriority.value) ? +bulkPriority.value : null); bulkPriority.value = ''"
        class="px-2.5 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
        <option value="">Cambiar prioridad…</option>
        @for (p of priorities; track p.id) {
          <option [value]="p.id">{{ p.label }}</option>
        }
      </select>

      <!-- Antes era un `input type="number"` que pedía el id del usuario a mano: nadie se
           sabe los ids. Mismo patrón que los dos selectores de al lado. -->
      <select #bulkOwner
        [disabled]="bulkInFlight"
        (change)="bulkAssignTo($any(bulkOwner.value) ? +bulkOwner.value : null); bulkOwner.value = ''"
        class="px-2.5 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
        <option value="">Asignar a…</option>
        @for (u of users; track u.id) {
          <option [value]="u.id">{{ userLabel(u) }}</option>
        }
      </select>

      @if (verArchivados) {
        <button type="button" (click)="bulkUnarchive()"
          [disabled]="bulkInFlight"
          class="px-2.5 py-1 text-xs rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
          Desarchivar
        </button>
      } @else {
        <button type="button" (click)="bulkArchive()"
          [disabled]="bulkInFlight"
          class="px-2.5 py-1 text-xs rounded-lg font-medium border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed">
          Archivar
        </button>
      }
    </div>
  </div>
  }

  <!-- Loading -->
  @if (loading) {
  <div class="flex justify-center items-center py-12">
    <div class="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-500"></div>
    <span class="ml-3 text-gray-500 dark:text-gray-400">Cargando tickets...</span>
  </div>
  }

  <!-- Error -->
  @if (error) {
  <div class="p-4 bg-error-50 border border-error-200 rounded-lg dark:bg-error-500/10 dark:border-error-500/20">
    <p class="text-error-600 dark:text-error-400">{{ error }}</p>
  </div>
  }

  <!-- Tabla -->
  @if (!loading && !error) {
  <div class="overflow-hidden rounded-xl border border-gray-200 bg-white dark:border-gray-800 dark:bg-white/[0.03]">
    <div class="max-w-full overflow-x-auto custom-scrollbar">
      <table class="min-w-full">
        <thead class="border-b border-gray-100 dark:border-white/[0.05]">
          <tr>
            <th class="px-3 py-3">
              <input type="checkbox" [checked]="allSelected" (change)="toggleAll()"
                class="rounded border-gray-300 dark:border-gray-600" />
            </th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Número</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Asunto</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Prioridad</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Estado</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Categoría</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Origen</th>
            <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Creado</th>
            @if (verArchivados) {
              <th class="px-5 py-3 font-medium text-gray-500 text-start text-theme-xs dark:text-gray-400">Archivado</th>
            }
            <th class="px-5 py-3 font-medium text-gray-500 text-center text-theme-xs dark:text-gray-400">Acciones</th>
          </tr>
        </thead>

        <tbody class="divide-y divide-gray-100 dark:divide-white/[0.05]">
          @if (displayRows.length === 0) {
          <tr>
            <td [attr.colspan]="verArchivados ? 10 : 9" class="px-5 py-8 text-center">
              <div class="flex flex-col items-center gap-2 text-gray-500 dark:text-gray-400">
                <svg class="w-12 h-12" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1"
                    d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
                </svg>
                <span>{{ verArchivados ? 'No hay tickets archivados' : 'No hay tickets que coincidan con los filtros' }}</span>
              </div>
            </td>
          </tr>
          }

          @for (row of displayRows; track row.ticket.id) {
          <tr [class.bg-yellow-50]="isSelected(row.ticket.id)" [class.dark:bg-yellow-900/10]="isSelected(row.ticket.id)"
            [class.bg-gray-50/60]="row.isChild" [class.dark:bg-white/[0.02]]="row.isChild">
            <td class="px-3 py-3">
              <input type="checkbox" [checked]="isSelected(row.ticket.id)" (change)="toggleSelect(row.ticket.id)"
                class="rounded border-gray-300 dark:border-gray-600" />
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="text-xs font-mono text-gray-600 dark:text-gray-400">{{ row.ticket.ticketNumber }}</span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <div class="flex items-center gap-1.5" [class.pl-6]="row.isChild">
                @if (row.hasChildren) {
                  <button type="button" (click)="toggleExpand(row.ticket.id)"
                    class="shrink-0 rounded p-0.5 text-gray-400 hover:bg-gray-100 hover:text-gray-600 dark:hover:bg-white/[0.05] dark:hover:text-gray-200 transition-colors"
                    [title]="row.expanded ? 'Colapsar subtickets' : 'Expandir subtickets'">
                    <svg class="w-4 h-4 transition-transform" [class.rotate-90]="row.expanded"
                      fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7"></path>
                    </svg>
                  </button>
                } @else if (row.isChild) {
                  <span class="shrink-0 text-gray-400 dark:text-gray-500" title="Subticket / división">↳</span>
                }
                <span class="block font-medium text-gray-800 dark:text-white/90 cursor-pointer hover:text-brand-500"
                  (click)="verDetalleModal(row.ticket)">
                  {{ row.ticket.subject }}
                </span>
              </div>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <app-badge [color]="getPriorityColor(row.ticket.idTicketPriority)">
                {{ getPriorityLabel(row.ticket.idTicketPriority) }}
              </app-badge>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <app-badge [color]="getStatusColor(row.ticket.idTicketStatus)">
                {{ getStatusLabel(row.ticket.idTicketStatus) }}
              </app-badge>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              {{ getCategoryName(row.ticket.idTicketCategory) }}
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              <span class="text-xs">{{ origenLabel(row.ticket.source) }}</span>
            </td>
            <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
              {{ row.ticket.datetimeCreated | date:'dd/MM/yyyy' }}
            </td>
            @if (verArchivados) {
              <td class="px-4 py-3 text-gray-500 text-start text-theme-sm dark:text-gray-400">
                <span class="block">{{ row.ticket.archivedAt | date:'dd/MM/yyyy HH:mm' }}</span>
                @if (row.ticket.archivedByName) {
                  <span class="block text-xs text-gray-400 dark:text-gray-500">por {{ row.ticket.archivedByName }}</span>
                }
              </td>
            }
            <td class="px-4 py-3 text-gray-500 text-center text-theme-sm dark:text-gray-400">
              <div class="flex items-center justify-center gap-2">
                <button (click)="verDetalleModal(row.ticket)"
                  class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 dark:hover:text-brand-400 transition-colors"
                  title="Ver detalle">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"></path>
                  </svg>
                </button>
                <button (click)="editarTicket(row.ticket)"
                  *appHasPermission="'tickets:edit'"
                  class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                  title="Editar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z"></path>
                  </svg>
                </button>
                @if (verArchivados) {
                  <button (click)="desarchivarTicket(row.ticket)"
                    *appHasPermission="'tickets:edit'"
                    class="rounded-lg p-2 hover:bg-brand-50 hover:text-brand-600 dark:hover:bg-brand-900/20 dark:hover:text-brand-400 transition-colors"
                    title="Desarchivar">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 4h16v4H4V4zm1 4h14v11a1 1 0 01-1 1H6a1 1 0 01-1-1V8zm7 9V11m0 0l-2.5 2.5M12 11l2.5 2.5"></path>
                    </svg>
                  </button>
                } @else {
                  <button (click)="archivarTicket(row.ticket)"
                    *appHasPermission="'tickets:edit'"
                    class="rounded-lg p-2 hover:bg-gray-100 dark:hover:bg-white/[0.05] transition-colors"
                    title="Archivar">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                        d="M4 4h16v4H4V4zm1 4h14v11a1 1 0 01-1 1H6a1 1 0 01-1-1V8zm4.5 4h5"></path>
                    </svg>
                  </button>
                }
                <button (click)="eliminarTicket(row.ticket)"
                  *appHasPermission="'tickets:delete'"
                  class="rounded-lg p-2 hover:bg-error-50 hover:text-error-600 transition-colors"
                  title="Eliminar">
                  <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16"></path>
                  </svg>
                </button>
              </div>
            </td>
          </tr>
          }
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    @if (globalTotalPages >= 1) {
    <div class="mt-4 border-t border-gray-200 dark:border-gray-700 pt-4 px-5 pb-4">
      <div class="flex items-center justify-between gap-4 flex-wrap">
        <div class="flex items-center gap-2">
          <span class="text-sm text-gray-500 dark:text-gray-400">{{ globalTotalElements }} registros</span>
          <select [ngModel]="pageSize" (ngModelChange)="changePageSize($event)"
            class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
            @for (opt of PAGE_SIZE_OPTIONS; track opt) {
              <option [value]="opt">{{ opt }}</option>
            }
          </select>
        </div>
        <div class="flex items-center gap-2">
          <button type="button" (click)="cambiarPagina(globalPage - 1)" [disabled]="!hasPrevPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Anterior
          </button>
          <div class="flex items-center gap-1.5">
            <span class="text-sm text-gray-500 dark:text-gray-400">Página</span>
            <select [ngModel]="pageDisplay" (ngModelChange)="cambiarPagina($event - 1)"
              class="px-2 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500 focus:border-transparent">
              @for (p of pagesArray; track p) {
                <option [value]="p">{{ p }}</option>
              }
            </select>
            <span class="text-sm text-gray-500 dark:text-gray-400">de {{ globalTotalPages }}</span>
          </div>
          <button type="button" (click)="cambiarPagina(globalPage + 1)" [disabled]="!hasNextPage"
            class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-40 disabled:cursor-not-allowed transition-colors">
            Siguiente
          </button>
        </div>
      </div>
    </div>
    }
  </div>
  }
</div>

<!-- Modal de detalle -->
<app-tickets-detail-modal
  [isOpen]="showDetailModal"
  [ticket]="selectedTicket"
  [priorities]="priorities"
  [statuses]="statuses"
  [categories]="categories"
  [pipelines]="pipelines"
  (refetch)="cargarTickets()"
  (close)="cerrarModalDetalle()">
</app-tickets-detail-modal>

<!-- ======== Modal: Búsqueda avanzada ======== -->
<app-modal [isOpen]="showAdvancedModal" (close)="cerrarAdvancedModal()" className="max-w-2xl mx-4">
  <div class="p-6 space-y-4">
    <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Búsqueda avanzada</h2>

    <div class="flex items-center gap-2">
      <span class="text-sm text-gray-700 dark:text-gray-300">Combinar con:</span>
      <select [(ngModel)]="advancedCombinator"
        class="px-2.5 py-1 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
        <option value="AND">AND (todas)</option>
        <option value="OR">OR (al menos una)</option>
      </select>
    </div>

    <div class="space-y-2">
      @for (cond of advancedConditions; track $index; let i = $index) {
        <div class="flex items-center gap-2 flex-wrap">
          <select [(ngModel)]="cond.field" (ngModelChange)="onFieldChange(cond)"
            class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
            @for (f of fieldOptions; track f.value) {
              <option [value]="f.value">{{ f.label }}</option>
            }
          </select>
          <select [(ngModel)]="cond.operator"
            class="w-36 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
            @for (op of operatorOptions; track op) {
              <option [value]="op">{{ operatorLabel(op) }}</option>
            }
          </select>

          @if (needsValue(cond.operator)) {
            @switch (fieldKind(cond.field)) {
              @case ('priority') {
                <select [(ngModel)]="cond.valueText"
                  class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                  <option value="">— Elegir —</option>
                  @for (p of priorities; track p.id) {
                    <option [value]="p.id">{{ p.label }}</option>
                  }
                </select>
              }
              @case ('status') {
                <select [(ngModel)]="cond.valueText"
                  class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                  <option value="">— Elegir —</option>
                  @for (s of statuses; track s.id) {
                    <option [value]="s.id">{{ s.label }}</option>
                  }
                </select>
              }
              @case ('category') {
                <select [(ngModel)]="cond.valueText"
                  class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                  <option value="">— Elegir —</option>
                  @for (c of categories; track c.id) {
                    <option [value]="c.id">{{ c.name }}</option>
                  }
                </select>
              }
              @case ('pipeline') {
                <select [(ngModel)]="cond.valueText"
                  class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                  <option value="">— Elegir —</option>
                  @for (p of pipelines; track p.id) {
                    <option [value]="p.id">{{ p.name }}</option>
                  }
                </select>
              }
              @case ('stage') {
                <select [(ngModel)]="cond.valueText"
                  class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                  <option value="">— Elegir —</option>
                  @for (st of allStages; track st.id) {
                    <option [value]="st.id">{{ st.name }}</option>
                  }
                </select>
              }
              @case ('owner') {
                <select [(ngModel)]="cond.valueText"
                  class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                  <option value="">— Elegir —</option>
                  @for (u of users; track u.id) {
                    <option [value]="u.id">{{ userLabel(u) }}</option>
                  }
                </select>
              }
              @case ('source') {
                <select [(ngModel)]="cond.valueText"
                  class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                  <option value="">— Elegir —</option>
                  @for (s of sourceOptions; track s) {
                    <option [value]="s">{{ origenLabel(s) }}</option>
                  }
                </select>
              }
              @case ('csat') {
                <select [(ngModel)]="cond.valueText"
                  class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
                  <option value="">— Elegir —</option>
                  @for (n of csatOptions; track n) {
                    <option [value]="n">{{ n }}</option>
                  }
                </select>
              }
              @case ('date') {
                <input type="date" [(ngModel)]="cond.valueText"
                  class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white" />
              }
              @case ('contact') {
                <div class="flex-1 min-w-40">
                  <app-entity-select
                    [value]="condIdValue(cond)"
                    (valueChange)="onCondEntityChange(cond, $event)"
                    (selected)="cond.valueLabel = $event ? contactLabel($event) : ''"
                    [displayText]="cond.valueLabel || ''"
                    [searchFn]="contactSearch" [labelFn]="contactLabel" [sublabelFn]="contactSublabel"
                    placeholder="Buscar contacto…"></app-entity-select>
                </div>
              }
              @case ('company') {
                <div class="flex-1 min-w-40">
                  <app-entity-select
                    [value]="condIdValue(cond)"
                    (valueChange)="onCondEntityChange(cond, $event)"
                    (selected)="cond.valueLabel = $event ? companyLabel($event) : ''"
                    [displayText]="cond.valueLabel || ''"
                    [searchFn]="companySearch" [labelFn]="companyLabel" [sublabelFn]="companySublabel"
                    placeholder="Buscar empresa…"></app-entity-select>
                </div>
              }
              @default {
                <input type="text" [(ngModel)]="cond.valueText"
                  [placeholder]="cond.operator === 'IN' || cond.operator === 'NOT_IN' ? 'a, b, c' : 'valor'"
                  class="flex-1 min-w-32 px-2 py-1 text-xs border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white" />
              }
            }
          }
          <button type="button" (click)="removerCondicion(i)"
            class="px-2 py-1 text-xs text-error-500 hover:text-error-700">×</button>
        </div>
      }
    </div>

    <button type="button" (click)="agregarCondicion()"
      class="text-xs text-brand-500 hover:text-brand-700">+ Agregar condición</button>

    <div class="flex justify-end gap-2 pt-3 border-t border-gray-200 dark:border-gray-700">
      <button type="button" (click)="cerrarAdvancedModal()"
        class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
        Cancelar
      </button>
      <button type="button" (click)="aplicarAdvanced()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600">
        Aplicar
      </button>
    </div>
  </div>
</app-modal>

<!-- ======== Modal: Guardar vista ======== -->
<app-modal [isOpen]="showSaveViewModal" (close)="cerrarSaveViewModal()" className="max-w-md mx-4">
  <div class="p-6 space-y-4">
    <h2 class="text-lg font-semibold text-gray-900 dark:text-white">Guardar vista</h2>
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">
        Nombre <span class="text-error-500">*</span>
      </label>
      <input type="text" [(ngModel)]="newViewName" maxlength="150"
        placeholder="Ej: Mis tickets urgentes"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:ring-2 focus:ring-brand-500" />
    </div>
    <div>
      <label class="block text-xs font-medium text-gray-700 dark:text-gray-300 mb-1">Alcance</label>
      <select [(ngModel)]="newViewScope"
        class="w-full px-2.5 py-1.5 text-sm border border-gray-300 dark:border-gray-600 rounded-lg bg-white dark:bg-gray-800 text-gray-900 dark:text-white">
        <option value="PRIVATE">Privado (solo yo)</option>
        <option value="PUBLIC">Público (todos)</option>
        <option value="TEAM">Equipo (mi equipo)</option>
      </select>
    </div>
    <div class="flex justify-end gap-2 pt-3 border-t border-gray-200 dark:border-gray-700">
      <button type="button" (click)="cerrarSaveViewModal()"
        class="px-3 py-1.5 text-sm rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 hover:bg-gray-50 dark:hover:bg-gray-700">
        Cancelar
      </button>
      <button type="button" (click)="guardarVista()" [disabled]="!newViewName.trim()"
        class="px-3 py-1.5 text-sm rounded-lg font-medium bg-brand-500 text-white hover:bg-brand-600 disabled:opacity-50 disabled:cursor-not-allowed">
        Guardar
      </button>
    </div>
  </div>
</app-modal>
